import { RefreshCw } from "lucide-react";

const ago = (iso) => {
  if (!iso) return "-";
  const m = Math.round((Date.now() - new Date(iso)) / 60000);
  return m < 1 ? "agora" : m < 60 ? `há ${m} min` : `há ${Math.round(m / 60)} h`;
};

export const SyncBar = ({ accounts, renewals, onRefresh }) => {
  const last = accounts.map((a) => a.last_success).filter(Boolean).sort().pop();
  const ok = accounts.length && accounts.every((a) => a.status === "ok");
  return (
    <div data-testid="bar-sync-status" className="flex flex-wrap items-center gap-x-5 gap-y-2 rounded-xl border border-[#1F293D] bg-[#0F141F] px-4 py-2.5 text-xs text-slate-400">
      <span className="flex items-center gap-2">
        <span className={`h-2 w-2 rounded-full ${ok ? "bg-emerald-400 animate-pulse" : "bg-amber-400"}`} />
        API SYSLOG {ok ? "conectada" : "com alerta"} · {accounts.length} contas
      </span>
      <span>Última atualização: <b className="text-slate-200">{ago(last)}</b></span>
      <span>Renovações detectadas: <b className="font-mono text-emerald-300">{renewals}</b></span>
      <button data-testid="dashboard-refresh" onClick={onRefresh}
        className="ml-auto flex items-center gap-1.5 rounded-lg border border-[#202D45] bg-[#1A2234] px-3 py-1.5 text-slate-300 transition-colors hover:border-[#334155] hover:text-white">
        <RefreshCw className="h-3.5 w-3.5" /> Atualizar
      </button>
    </div>
  );
};
